export let externalStoredData = {}
export let externalStoredGeojson = {}